class FfCountryPopup extends HTMLElement {
  constructor() {
    super();

    this.buttonClose = this.querySelector(".ff-country-popup-close");
    this.buttonEnterSite = this.querySelector(".ff-country-popup-link");
    this.expiresInDays = this.dataset.expiresIn;

    this.popupDismissed = document.cookie.replace(
      /(?:(?:^|.*;\s*)country-popup-dismissed\s*\=\s*([^;]*).*$)|^.*$/,
      "$1"
    );

    if (this.popupDismissed === "true") this.classList.add("hide");

    [this.buttonClose, this.buttonEnterSite].forEach((el) =>
      el.addEventListener("click", () => this.close())
    );
  }

  close() {
    this.classList.add("hide");
    document.cookie = `country-popup-dismissed=true${
      this.expiresInDays <= 0
        ? ""
        : `;max-age=${60 * 60 * 24 * this.expiresInDays}`
    }`;
  }
}

customElements.define("ff-country-popup", FfCountryPopup);
